<template>
  <!-- 服务费模板 -->
  <div class="template-list main-container">
    <cover v-show="firstEntryPage" @on-direct="directFee" @on-template="templateFee" @on-back="templateFee" :coverShowBack="coverShowBack"></cover>
    <div v-show="!firstEntryPage">
      <div class="config-text">
        <a class="name" @click="showCommissionExplain">费用配置方式介绍</a>
      </div>
      <div class="main-panel">
        <div class="search-box gauge_20">
          <div class="input-item">
            <span class="label">模板名称</span>
            <Input clearable v-model="search.name" placeholder="请输入" />
          </div>
          <div class="input-item">
            <span class="label">模板类型</span>
            <Select v-model="search.type" clearable>
              <Option value="1">机构</Option>
              <Option value="2">团队</Option>
            </Select>
          </div>
          <div class="input-item big-label">
            <span class="label">使用机构/团队</span>
            <selectTree v-model="search.applyOrgId" type="1"></selectTree>
          </div>
          <div class="input-item">
            <span class="label">所属机构</span>
            <selectTree v-model="search.orgId" type="3"></selectTree>
          </div>
          <div class="input-item">
            <span class="label">产品名称</span>
            <Input clearable v-model="search.productName" placeholder="请输入" />
          </div>
          <div class="btn-item">
            <Button type="primary" @click="searchAjax(1)">查询</Button>
            <Button type="warning" @click="openTemplateEdit({})">新建</Button>
          </div>
        </div>
        <div class="table-box template-table">
          <loading :isShow="tableLoading" />
          <Table :columns="columns" :data="tableData" border>
            <template slot-scope="{ row }" slot="id">
              <div class="key-name">{{row.name}}</div>
              <div class="key-id">模板ID：{{row.id}}</div>
            </template>
            <template slot-scope="{ row }" slot="type">
              <span v-if="row.type==0">平台</span>
              <span v-if="row.type==1">机构</span>
              <span v-if="row.type==2">团队</span>
            </template>
            <template slot-scope="{ row }" slot="team">
              <span class="table-num" @click="openTemplateUserDetail(row)">{{row.applyNum}}</span>
            </template>
            <template slot-scope="{ row }" slot="product">
              <span class="table-num" @click="goTemplateDetail(row)">{{row.productNum}}</span>
            </template>
            <template slot-scope="{ row }" slot="isExtends">
              <Tooltip content="无权操作，请联系您的上级" v-if="!$units.pointAction('commission_20_1')">
                <i-Switch :disabled="true" :value="row.isExtends" true-value="1" false-value="0" @on-change="editIsExtendsVal(row)" />
              </Tooltip>
              <i-Switch v-else :value="row.isExtends" true-value="1" false-value="0" @on-change="editIsExtendsVal(row)" />
            </template>
            <template slot-scope="{ row }" slot="updateTime">
              <span>{{row.updateTime|cutString(16)}}</span>
            </template>
            <template slot-scope="{ row }" slot="action">
              <div class="action-box">
                <span class="table-btn" @click="goTemplateDetail(row)">查看详情</span>
                <span class="table-btn" @click="openTemplateEdit(row)">编辑名称</span>
                <Poptip confirm transfer title="确定复制模板吗?" @on-ok="copyTemplate(row)">
                  <span class="table-btn">复制</span>
                </Poptip>

                <Poptip
                  trigger="hover"
                  placement="top-end"
                  transfer-class-name="my-poptip left3"
                  transfer
                  v-if="row.applyNum!=0"
                >
                  <span class="table-btn red" :class="{'disabled':row.applyNum!=0}" @click="row.applyNum==0&&delTemplate(row)">删除</span>
                  <div slot="content">
                    <p>有{{row.type==1?'机构' : '团队'}}正在使用该模板，不能删除</p>
                  </div>
                </Poptip>
                <span v-if="row.applyNum==0" class="table-btn red" :class="{'disabled':row.applyNum!=0}" @click="row.applyNum==0&&delTemplate(row)">删除</span>         
              </div>
            </template>
          </Table>
          <Page
            :total="total"
            :current.sync="pageNum"
            :page-size="pageSize"
            show-total
            @on-change="getList"
            style="text-align: center; margin-top: 20px"
          />
        </div>
      </div>
    </div>

    <!-- 模板新增、编辑 -->
    <editTemplate ref="editTemplate" @success="getList"></editTemplate>

    <!-- 模板使用详情 -->
    <templateUserDetail ref="templateUserDetail" @success="getList"></templateUserDetail>
  </div>
</template>

<script>
import { common } from '@/api/mixins';
import selectTree from "@/components/system/selectTree3";
import templateUserDetail from "@/components/commons/feeTemplate/templateUserDetail";
import editTemplate from "@/components/commons/feeTemplate/editTemplate";
import cover from './cover.vue';

export default {
  mixins: [common],

  components: { editTemplate, templateUserDetail, selectTree, cover },

  data() {
    return {
      coverShowBack: false,
      firstEntryPage: false,
      companyList: [],//保险公司
      search: {},//查询数据
      tableLoading: false,//表格loading
      tabActive:"1",
      columns: [],
      tableData: [],//表格数据
      total: 0,//表格记录数
      pageSize: 10,//页容量
      pageNum: 1,//当前页
      form: {},//表单数据
      formVisible: false,//表单弹窗
    };
  },

  activated() {
    if(this.$units.superviseShowVal()) {
      this.columns = [
        {
          title: "模板名称/ID",
          slot: "id",
          align: "left",
          width:220,
        },
        {
          title: "模板类型",
          slot: "type",
          align: "center",
          width:100
        },
        {
          title: "使用机构/团队",
          slot: "team",
          align: "center",
          width:130
        },
        {
          title: "模板内产品",
          slot: "product",
          align: "center",
          width:110
        },
        {
          title: "新产品自动加入模板",
          slot: "isExtends",
          align: "center",
          width:150
        },
        {
          title: "备注",
          key: "remarks",
          align: "center",
          minWidth:160,   
          render(h, params) {
              let text = params.row.remarks;
              return h(
                  'Tooltip',
                  {
                      class:'flex-center',
                      props: { placement: 'bottom-start', transfer: true }
                  },
                  [
                      h(
                          'span',
                          {
                              class: 'txt-ellipsis2'
                          },
                          text
                      ),
                      h('span', { slot: 'content'}, text)
                  ]
              );
          }
        },
        {
          title: "所属机构",
          key: "orgName",
          align: "center",
          minWidth:100
        },
        {
          title: "更新时间",
          slot: "updateTime",
          align: "center",
          width: 150
        },
        {
          title: "操作",
          slot: "action",
          align: "center",
          width: 280,
          fixed:'right'
        },
      ]
    }else{
      this.columns = [
        {
          title: "模板名称/ID",
          slot: "id",
          align: "left",
          width:220,
        },
        {
          title: "模板类型",
          slot: "type",
          align: "center",
          width:100
        },
        {
          title: "模板内产品",
          slot: "product",
          align: "center",
          width:110
        },
        {
          title: "新产品自动加入模板",
          slot: "isExtends",
          align: "center",
          width:150
        },
        {
          title: "备注",
          key: "remarks",
          align: "center",
          minWidth:160,   
          render(h, params) {
              let text = params.row.remarks;
              return h(
                  'Tooltip',
                  {
                      class:'flex-center',
                      props: { placement: 'bottom-start', transfer: true }
                  },
                  [
                      h(
                          'span',
                          {
                              class: 'txt-ellipsis2'
                          },
                          text
                      ),
                      h('span', { slot: 'content'}, text)
                  ]
              );
          }
        },
        {
          title: "所属机构",
          key: "orgName",
          align: "center",
          minWidth:100
        },
        {
          title: "更新时间",
          slot: "updateTime",
          align: "center",
          width: 150
        },
        {
          title: "操作",
          slot: "action",
          align: "center",
          width: 280,
          fixed:'right'
        },
      ]
    }
    this.getList();
    this.firstPage();
  },

  methods: {
    // 判断是否首次进入页面
    firstPage() {
      let firstTemplatePage = window.localStorage.getItem('first_template_page');
      let show = this.$route.query.show;
      if (firstTemplatePage == '0') {
        this.firstEntryPage = false;
      } else {
        this.firstEntryPage = true;
        window.localStorage.setItem('first_template_page', 0);
      }
      if (show == '1') {
        this.firstEntryPage = true;
      }
    },

    // 直接配费
    directFee() {
      window.localStorage.setItem('first_template_page', 0);
      this.$router.push({
        path: '/productResource/fee/config'
      })
    },

    // 模板配费
    templateFee() {
      window.localStorage.setItem('first_template_page', 0);
      this.firstEntryPage = false;
    },

    showCommissionExplain() {
      this.firstEntryPage = !this.firstEntryPage;
      this.coverShowBack = true;
    },

    // 删除模板
    delTemplate(item) {
      if(!this.$units.pointAction('commission_20_2')){
        this.$notice.error('无权操作，请联系您的上级');
        return
      }
      this.$notice.inquiry("确定删除模板？").then(() => {
        this.$http({
          url: "/buz/template/logic/del",
          type: "get",
          data: {
            id: item.id
          },
          apiPermissionCode:'commission_20_2'
        }).then(res => {
          this.$notice.success("删除模板成功");
          this.getList();
        });
      });
    },
    // 复制模板
    copyTemplate(item) {
      if(!this.$units.pointAction('commission_20_1')){
        this.$notice.error('无权操作，请联系您的上级');
        return
      }
      if(this.tableLoading){
        return;
      }
      this.tableLoading = true;
      this.$http({
        url: "/buz/template/copy",
        type: "get",
        data: {
          id: item.id
        },
        apiPermissionCode : 'commission_20_1'
      }).then(res => {
        this.$notice.success("复制模板成功");
        this.getList();
        this.tableLoading = false;
      }).catch(e=>{
        this.tableLoading = false;
      });
    },
    // 打开模板编辑或新增弹窗
    openTemplateEdit(item) {
      if(!this.$units.pointAction('commission_20_1')){
        this.$notice.error('无权操作，请联系您的上级');
        return
      }
      item.apiPermissionCode = 'commission_20_1'
      item.showSupplier = this.$units.pointAction('commission_20_5')?true:false;
      this.$refs.editTemplate.open(item || {});
    },
    // 打开模板使用者弹窗
    openTemplateUserDetail(item) {
      this.$refs.templateUserDetail.open(item);
    },
    // 跳转费率表
    goRate() {
      this.$router.push({
        path: "./rateDetail"
      });
    },
    // 编辑新产品自动加入模板
    editIsExtendsVal(row) {
      this.$http({
        url: '/buz/template/edit',
        type: 'post',
        data: {
          ...row,
          isExtends: row.isExtends == '0'?"1":"0"
        }
      }).then(res => {
        this.getList();
      })            
    },
    // 跳转模板详情
    goTemplateDetail(item) {
      this.openPageTabTags(
          '/productResource/fee/templateDetail', 
          {
            id: item.id,
            type: item.type,
            orgId: item.orgId,
            redirectPagePath: 'commissionTemplate'
          }
      );
    },
    // 获取列表参数
    getParams() {
      const params = Object.assign({}, this.search);
      return params;
    },
    searchAjax() {
      this.pageNum = 1;
      this.getList();
    },
    // 获取列表数据
    getList() {
      const params = this.getParams();
      params.pageNo = this.pageNum;
      params.pageSize = this.pageSize;
      this.tableLoading = true;
      this.$http({
        url: "/buz/template/read/list",
        type: "post",
        data: params,
        apiPermissionCode:'commission_20_0'
      })
        .then(res => {
          this.tableLoading = false;
          this.tableData = res.data;
          this.total = res.total;
        })
        .catch(e => {
          this.tableLoading = false;
        });
    }
  }
};
</script>
<style lang="scss" scoped>
@import "./templateList.scss";
</style>